import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import CardsSection from './components/CardsSection';
import UpdatesSection from './components/UpdatesSection';
import ContactSection from './components/ContactSection';
import RankingSection from './components/RankingSection';
import TopicsSection from './components/TopicsSection';
import FaqSection from './components/FaqSection';
import AppSection from './components/AppSection';
import FeaturesSection from './components/FeaturesSection';
import CarouselSection from './components/CarouselSection';
import MediaSection from './components/MediaSection';
import CommentsSection from './components/CommentsSection';
import IndexSection from './components/IndexSection';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <CardsSection />
        <UpdatesSection />
        <ContactSection />
        <RankingSection />
        <TopicsSection />
        <FaqSection />
        <AppSection />
        <FeaturesSection />
        <CarouselSection />
        <MediaSection />
        <CommentsSection />
        <IndexSection />
      </main>
      <Footer />
    </>
  );
}